export const Event = {
    PAGE_LOAD: 'app.pageload',
    PAGE_LEAVE: 'app.pageleave',
};
export const passiveListenerSupported = () => {
    let passiveSupported = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
            }
        });
        window.addEventListener('test', null, opts);
        window.removeEventListener('test', null, opts);
    }
    catch (err) { }
    return passiveSupported;
};
